import { StashTag } from '../db/constants';
import { removeTag } from '../db/pages';
import { activateTab } from './chromeActions';
import { logger } from '../utils/logger';

function isWebUrl(url: string): boolean {
  return url.startsWith('http://') || url.startsWith('https://');
}

export async function openTab(windowId: number, url: string): Promise<void> {
  if (!isWebUrl(url)) {
    logger.warn('[chromeNavigation] openTab: ignoring non-web URL', url);
    return;
  }
  removeTag([url], StashTag);
  await chrome.tabs.create({ windowId, url }).catch((e: unknown) => logger.warn('[chromeNavigation] openTab: chrome.tabs.create failed', e));
}

export async function activateOrOpenTab(rawUrl: string, windowId?: number, tabId?: number): Promise<void> {
  if (!isWebUrl(rawUrl)) {
    logger.warn('[chromeNavigation] activateOrOpenTab: ignoring non-web URL', rawUrl);
    return;
  }
  if (windowId && tabId) {
    activateTab(windowId, tabId);
  } else if (windowId) {
    await openTab(windowId, rawUrl);
  } else {
    await chrome.tabs.create({ url: rawUrl }).catch((e: unknown) => logger.warn('[chromeNavigation] activateOrOpenTab: chrome.tabs.create failed', e));
  }
}
